// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".meta-container[data-v-9fc864a2]{margin:.3125rem 1.25rem 1.25rem;box-sizing:border-box;display:flex;flex-direction:column;justify-content:center;align-items:center}@media(min-width:48rem){.meta-container[data-v-9fc864a2]{margin:1.25rem;margin-bottom:0}}.meta-container.ph-loading--content[data-v-9fc864a2]{min-width:12.5rem}@media(min-width:48rem){.meta-container.ph-loading--content[data-v-9fc864a2]{min-width:31.25rem}}", ""]);
// Exports
module.exports = exports;
